import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

export const providersColumns = [
  {
    label: "Name",
    field: "name",
    xs: 5,
    sm: 5,
    md: 5,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name ?? ""}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 7,
    sm: 7,
    md: 7,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality ?? ""}</TextFieldWithEllipsis>
    ),
  },
];

export const providersMobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 5,
    sm: 5,
    md: 5,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name ?? ""}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 7,
    sm: 7,
    md: 7,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality ?? ""}</TextFieldWithEllipsis>
    ),
  },
];
